<template><!-- svgo-disable -->
<svg class="icon icon__chevron icon__chevron--down" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-labelledby="chevronDown" role="img">
  <title id="chevronDown">Chevron Down Icon</title>
  <path d="M1.125 4.45398C3.22184 6.84556 5.62184 10.214 8.51026 11.8898C8.99026 10.9719 9.15026 10.2729 9.85763 9.34662C11.4408 7.26662 13.0745 5.2203 14.8766 3.33398" stroke="black" stroke-width="1.15" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>